var lib_core      = require("lib-core");
var lib_geometry      = require("lib-geometry");
var THREE         = require("three");
var RadialHandleModel  = require("./radialHandleModel.js");

var LocalRotationHandleModel = function (editorModel, handleId, config) {
    RadialHandleModel.call(this, editorModel, handleId);
    var self = this;
    this.config = config;

    // this type of handle can only have one subject
    this.multipleSubjects = false;

    this.startAngle = null
    this.startRotation = null;
    this.snapped = this.value("snapped", true);
    this.selected = this.value("selected", true);
};

lib_core.inherit(LocalRotationHandleModel, RadialHandleModel);
LocalRotationHandleModel.$class = "LocalRotationHandleModel";
module.exports = LocalRotationHandleModel;


LocalRotationHandleModel.prototype.getSubject = function(){
    return this.subjects.getOne();
} 

LocalRotationHandleModel.prototype.getSubjectsRadius = function(){
    return this.getSubject().getRadius();
} 

LocalRotationHandleModel.prototype.getSubjectsCenter = function(){
    return this.getSubject().getPosition();
} 

LocalRotationHandleModel.prototype.getSubjectsRotation = function(){
    return new lib_geometry.Coord3d();
} 

LocalRotationHandleModel.prototype.createMovementPlane = function(ray, point){}

LocalRotationHandleModel.prototype.setContactPosition = function(position){}

LocalRotationHandleModel.prototype.setMousePosition = function(position){}

LocalRotationHandleModel.prototype.released = function(){}
